import { render, staticRenderFns } from "./DashboardNotification.vue?vue&type=template&id=8bd64aae&scoped=true"
import script from "./DashboardNotification.vue?vue&type=script&lang=js"
export * from "./DashboardNotification.vue?vue&type=script&lang=js"
import style0 from "./DashboardNotification.vue?vue&type=style&index=0&id=8bd64aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd64aae",
  null
  
)

export default component.exports